<p>geo-fence works!</p>
